import { Directive, ElementRef, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[togDelayedSearch]'
})
export class DelayedSearchDirective {
  private _timeout: any;

  @Input() delay: number;
  @Input() keysToIgnore: number[] = [];
  @Output() onChange = new EventEmitter();

  @HostListener('keyup', ['$event']) 
  onInputChange(e: any, value: any) {
    if (this.keysToIgnore.indexOf(e.keyCode) > -1) return;

    let emitValue;
    if (e.target.value != undefined) {
      emitValue = e.target.value.toLowerCase();
    }

    if (this._timeout) clearTimeout(this._timeout);
    this._timeout = setTimeout(() => {
      this._timeout = null;
      this.onChange.emit({ filter: emitValue });
    }, this.delay);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/delayed-search/delayed-search.directive.ts